export interface DealOfferShippingPriceForDisplayInput {
  shippingPrice?: string | null;
  shippingCountsTowardTotal?: boolean | null;
}

export function dealOfferShippingPriceForDisplay(
  input: DealOfferShippingPriceForDisplayInput,
): string | null {
  if (input.shippingCountsTowardTotal !== true) return null;
  return input.shippingPrice ?? null;
}
